export default "__VITE_PUBLIC_ASSET__1784171c__"